// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","883":"component---src-pages-404-js","963":"component---src-components-home-index-js"}[chunkId] + "-" + {"532":"e18fd03242f48e565d39","883":"a137b1f058f6ea65acca","963":"924cc0db6141cd4ad8cf"}[chunkId] + ".js";
};